import { AfterViewInit, Component, HostListener, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { ComponentFactoryResolver, Injector, SimpleChange, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, of, toArray } from 'rxjs';
import { merge, Observable, of as observableOf, pipe } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelectChange } from '@angular/material/select';
import { ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent, ConfirmDialogData } from '../@shared/dialog/confirm-dialog/confirm-dialog.component';
import { StatusInfoDialogComponent, StatusInfoDialogData } from '../@shared/dialog/status-info/status-info-dialog.component';
import { NewItemWizardComponent } from './new-item-wizard/new-item-wizard.component';

import { TransferMandatService, TransferMandat, TransferMandatTable } from '../services/transfer.service';

import { PhutureIavatarComponent } from '../@components/phuture-iavatar/phuture-iavatar.component';

import { environment } from './../../environments/environment';
import { Logger } from '@core';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, MailService, Mail } from '@core';
import { DataChangeService } from './changes-transfer.service';
import { NavigationListService } from '../services/navigation-list.service';

declare var $: any;

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}

export interface filterOption {
  name: string;
  value: string;
  isdefault: boolean;
}

@Component({
  templateUrl: './transfer.component.html',
  styleUrls: [
    './transfer.component.scss',
    //'../../assets/dk/css/libs.bundle.css',
    //'../../assets/dk/css/theme.bundle.css'
  ],
})
export class TransferComponent implements OnInit {
  displayedColumns: string[] = [
    'select',
    //'id',
    'transferred',
    'aktenzeichen',
    'kzland',
    //'kzbezirk',
    'kznummer',
    //'plate',
    'street',
    //'createdate',
    //'createtime',
    //'printcount',
    //'tatzeit',
    'tat_datum',
    'tat_zeit',

    'tatbestnr',
    'person',
    'bom',

    'checked',

    'actions',

    /*
    id
    aktenzeichen
    plate
    kzland
    kzbezirk
    kznummer
    street
    streetnbr
    hersteller
    farbe
    createdate
    createtime
    dienstnr_id
    person
    tatbestnr
    konkretisierung
    printed
    printdate
    printcount
    mandat_id
    transferred
    transferdate
    notes
    info1
    info2
    info3
    longitude
    lattitude
    fahrzeugart
    zone
    ticketnr
    ticket_zeit
    zusatz1
    zusatz2
    strafe
    dienstnr_stvo
    transfer_db

    tatzeit
    tat_datum
    tat_zeit

     */
  ];

  current_aktenzeichen: string = ''; /// das aktuelle aktenzeichen (im sidenav)

  showBulkImport = environment.showBulkImport;

  get canSeeBulkImport(): boolean {
    return this.showBulkImport && this.authQuery.can('bulk-import');
  }

  get editingAllowed(): boolean {
    return this.authQuery.editingAllowed;
  }

  imageStorage = environment.serverUrl + '/'; // images gehen über api

  visitorTable: TransferMandatTable;

  totalItems: number;
  //visitors: Visitor[];

  //stats: VisitorStats;
  /*
  stat_nbr_visitors: Observable<number>;
  stat_nbr_exhibitors: Observable<number>;
  stat_nbr_appointments: Observable<number>;
  stat_nbr_registered: Observable<number>;
  stat_nbr_approved: Observable<number>;
  stat_nbr_fs_done: Observable<number>;
  */
  dataSubject = new BehaviorSubject<TransferMandat[]>([]);
  visitors$: Observable<TransferMandat[]>;
  dataSource = new MatTableDataSource<TransferMandat>();
  selection = new SelectionModel<TransferMandat>(true, []);
  showDropdown = false;

  isLoading = true;

  searchTerm$ = new BehaviorSubject<string>('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageSizes = [50, 100, 200, 500];

  searchValue: string;
  //searchKeywordFilter = new FormControl();

  stati: string[] = ['Alle', 'Entwurf', 'Transfer', 'Ungültig', 'Übertragen', 'Error'];

  empFilters: EmpFilter[] = [];
  defaultValue = 'Transfer';
  filterDictionary = new Map<string, string>();
  //dataSourceFilters = new MatTableDataSource();
  filters$ = new BehaviorSubject<string>('');

  // dilaog und sidenav
  openSidebar = false;
  @ViewChild('sidenav') sidenav;
  selectedVisitor: TransferMandat;
  @ViewChild('visitorContainer', { read: ViewContainerRef }) quizContainer: ViewContainerRef;
  currentTransferId: number | null = null;
  private subscription: Subscription; // changes in the eg sidebar

  constructor(
    private transferService: TransferMandatService,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private _snackBar: MatSnackBar,
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authQuery: AuthQuery,
    private changeDetectorRef: ChangeDetectorRef,
    private dataChangeService: DataChangeService,
    private navigationListService: NavigationListService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    //this.empFilters.push({ name: 'Land', options: this.countries, defaultValue: this.defaultValue });
    this.empFilters.push({ name: 'Status', options: this.stati, defaultValue: this.defaultValue });
    //this.empFilters.push({ name: 'Tatort', options: this.streets, defaultValue: this.defaultValue });

    // Set initial filter so the API gets it on first load
    this.filterDictionary.set('Status', this.defaultValue);
    this.filters$.next(JSON.stringify(Array.from(this.filterDictionary.entries())));

    // Track current transfer ID from child route for prev/next navigation
    this.route.firstChild?.paramMap.subscribe(params => {
      const id = params.get('id');
      this.currentTransferId = id ? +id : null;
    });

    // subscribe to the sidebar changes
    this.subscription = this.dataChangeService.dataChanges$.subscribe((data) => {
      if (data) {
        // Handle the data, e.g., update the list or form
        console.log('change recieved-----------');
        console.log(data);

        if (data.__reload) {
          // full reload requested (e.g. after a type change that stornos one record
          // and creates a new one) -> a single-row update is not enough
          this.reloadTable();
        } else {
          // update the specific transfer
          this.updateTransfer(data);
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // unsubscibe to the subscriptions
  }

  // --- Prev / Next navigation (offcanvas header) ---
  get hasPrevTransfer(): boolean {
    return this.currentTransferId !== null && this.navigationListService.getPrevTransferId(this.currentTransferId) !== null;
  }
  get hasNextTransfer(): boolean {
    return this.currentTransferId !== null && this.navigationListService.getNextTransferId(this.currentTransferId) !== null;
  }
  get transferPositionLabel(): string {
    return this.currentTransferId !== null ? this.navigationListService.getTransferPosition(this.currentTransferId) : '';
  }

  navigatePrevTransfer() {
    if (this.currentTransferId === null) return;
    const prevId = this.navigationListService.getPrevTransferId(this.currentTransferId);
    if (prevId !== null) {
      this.currentTransferId = prevId;
      const transfer = this.dataSource.data.find(t => +t.id === +prevId);
      if (transfer) this.current_aktenzeichen = transfer.aktenzeichen;
      this.router.navigate(['/transfer/edit', {
        id: prevId, _uid: prevId, _fid: prevId, _role: 3, _country: transfer?.plate || '', ia: 1
      }]);
    }
  }

  navigateNextTransfer() {
    if (this.currentTransferId === null) return;
    const nextId = this.navigationListService.getNextTransferId(this.currentTransferId);
    if (nextId !== null) {
      this.currentTransferId = nextId;
      const transfer = this.dataSource.data.find(t => +t.id === +nextId);
      if (transfer) this.current_aktenzeichen = transfer.aktenzeichen;
      this.router.navigate(['/transfer/edit', {
        id: nextId, _uid: nextId, _fid: nextId, _role: 3, _country: transfer?.plate || '', ia: 1
      }]);
    }
  }

  /**
   * Trigger a full reload of the table from the server.
   * Re-emits the current filters which re-runs the merge() data pipeline in ngAfterViewInit.
   */
  reloadTable(): void {
    this.filters$.next(this.filters$.getValue());
  }

  /**
   * update the datasource with the given data from the subscription
   */
  updateTransfer(updatedTransfer: TransferMandat) {
    const data = this.dataSubject.getValue();
    const index = data.findIndex((transfer) => +transfer.id === +updatedTransfer.id);
    if (index > -1) {
      data[index] = updatedTransfer;
      this.dataSubject.next(data); // Update the BehaviorSubject
      this.dataSource.data = data; // Update the MatTableDataSource
    }
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;

    merge(
      this.filters$,
      this.searchTerm$.pipe(debounceTime(400), distinctUntilChanged()),
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        startWith({}),
        switchMap((term) => {
          this.isLoading = true;
          //var sTerm = term && typeof term == 'string' ? term.toString() : '';
          const searchTerm = this.searchTerm$.getValue();
          let effectiveFilters = this.filters$.getValue();
          // When searching, ignore the selected status filter and search across all statuses
          if (searchTerm && searchTerm.trim() !== '') {
            const map = new Map<string, string>(JSON.parse(effectiveFilters || '[]'));
            map.set('Status', 'Alle');
            effectiveFilters = JSON.stringify(Array.from(map.entries()));
          }
          return this.getTableData$(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction,
            searchTerm,
            effectiveFilters
          ).pipe(catchError(() => observableOf(null)));
        }),
        map((visTable) => {
          if (visTable == null) return [];
          this.totalItems = visTable.total;
          this.isLoading = false;

          //this.stats = visTable.stats;

          return visTable.data.map((data) => {
            return <TransferMandat>{
              ...data,
              /*
              decharge_resp_civile: data.decharge_resp_civile == -1 ? 1 : 0,
              estimate: data.estimate == '-1' ? '1' : 0,
              garage_day1: data.garage_day1 == -1 ? 1 : 0,
              garage_day2: data.garage_day2 == -1 ? 1 : 0,
              lunch_day1: data.lunch_day1 == -1 ? 1 : 0,
              lunch_day2: data.lunch_day2 == -1 ? 1 : 0,
              attendance_event: data.attendance_event == -1 ? 1 : 0,
              hotel_stay_night: data.hotel_stay_night == -1 ? 1 : 0,
              transfer_arrival: data.transfer_arrival == -1 ? 1 : 0,
              transfer_return: data.transfer_return == -1 ? 1 : 0,
              flight_booked: data.flight_booked == -1 ? 1 : 0,
              */
            };
          });
          //return visTable.data;
        })
      )
      .subscribe((transfers: TransferMandat[]) => {
        this.visitors$ = of(transfers);
        this.dataSource = new MatTableDataSource(transfers);
        this.selection.clear();

        this.dataSubject.next(transfers);

        // Store sorted IDs for prev/next navigation in edit component
        this.navigationListService.setTransferIds(transfers.map(t => t.id));

        //reset paginator
        //this.paginator.pageIndex = 1;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.searchTerm$.next(filterValue);
  }

  /**
   * Reset the search and refresh the table. The status filter keeps its current selection.
   */
  clearSearch(): void {
    this.searchValue = '';
    this.searchTerm$.next('');
  }

  get showNoActiveTransfer(): boolean {
    return (
      !this.isLoading &&
      this.dataSource.data.length === 0 &&
      this.filterDictionary.get('Status') === 'Transfer' &&
      !(this.searchValue && this.searchValue.trim())
    );
  }

  get showNoResults(): boolean {
    return !this.isLoading && this.dataSource.data.length === 0 && !this.showNoActiveTransfer;
  }

  get showEmptyState(): boolean {
    return this.showNoActiveTransfer || this.showNoResults;
  }

  /**
   * Parse tatbestnr JSON and return comma-separated VSTV codes
   */
  parseDelikt(tatbestnr: string): string {
    if (!tatbestnr) return '';
    try {
      const parsed = JSON.parse(tatbestnr);
      if (Array.isArray(parsed)) {
        return parsed.join(', ');
      }
      return parsed ? String(parsed) : '';
    } catch {
      return tatbestnr; // fallback: return raw value
    }
  }

  /** Whether all rows are selected */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  /** Toggle select all / deselect all */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
    }
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  @HostListener('document:click')
  closeDropdown(): void {
    this.showDropdown = false;
  }

  /** Open the wizard to create a brand new item (Anzeige / BOM). */
  openNewItemWizard(): void {
    const dialogRef = this.dialog.open(NewItemWizardComponent, {
      panelClass: 'custom-dialog-container',
      width: '680px',
      maxWidth: '95vw',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.created) {
        // reload the list so the new draft becomes visible (when the Entwurf filter is active)
        this.filters$.next(this.filters$.getValue());
      }
    });
  }

  /** Navigate to the bulk-import (barcode scan) page. */
  goToBulkImport(): void {
    this.router.navigate(['/bulk-import']);
  }

  openStatusInfo(): void {
    this.dialog.open(StatusInfoDialogComponent, {
      data: {
        title: 'Transfer Status-Übersicht',
        items: [
          { label: 'Entwurf', description: 'Der Transfer wurde vom Mobilgerät empfangen, ist aber noch nicht zur Überführung freigegeben.' },
          { label: 'Transfer', description: 'Der Transfer ist geprüft und bereit zur Überführung in ein Mandat.' },
          { label: 'Übertragen', description: 'Der Transfer wurde erfolgreich in ein Mandat überführt.' },
          { label: 'Ungültig', description: 'Der Transfer wurde als ungültig markiert und wird nicht weiterverarbeitet.' },
          { label: 'Error', description: 'Bei der Verarbeitung des Transfers ist ein Fehler aufgetreten.' },
        ],
      } as StatusInfoDialogData,
    });
  }

  bulkSetTransferStatus(statusId: number): void {
    this.showDropdown = false;
    const selectedIds: number[] = this.selection.selected.map((r) => +r.id);
    if (selectedIds.length === 0) {
      this._snackBar.open('Bitte wählen Sie mindestens einen Eintrag aus.', 'Schließen', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }
    const statusLabels: { [key: number]: string } = { 0: 'Entwurf', 3: 'Ungültig' };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Status ändern',
        message: `${selectedIds.length} Einträge auf "${statusLabels[statusId]}" setzen. Möchten Sie fortfahren?`,
      } as ConfirmDialogData,
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.transferService.bulkSetTransferStatus({ selectedIds, statusId }).subscribe(
        (response: any) => {
          this._snackBar.open(
            `${response.updated ?? selectedIds.length} Einträge auf "${statusLabels[statusId]}" gesetzt.`,
            'Schließen',
            { duration: 3000, horizontalPosition: 'center', verticalPosition: 'top' }
          );
          this.selection.clear();
          this.filters$.next(this.filters$.getValue());
        },
        (error) => {
          console.error('Bulk status change failed', error);
          this._snackBar.open('Fehler beim Statuswechsel.', 'Schließen', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      );
    });
  }

  applyEmpFilter(ob: MatSelectChange, empfilter: EmpFilter) {
    this.filterDictionary.set(empfilter.name, ob.value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  applyNativeFilter(event: Event, empfilter: EmpFilter) {
    const value = (event.target as HTMLSelectElement).value;
    this.filterDictionary.set(empfilter.name, value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  getTableData$(pageNumber: Number, pageSize: Number, sort: string, order, searchTerm: string, filtersArgs: string) {
    // get data from server
    return this.transferService.getTransferMandate(pageNumber, pageSize, sort, order, searchTerm, filtersArgs);
  }

  /**
   * checkTransfer - check 3 things
   * // a) dublette auf aktenzeichen
     // b) falsches kennzeichen
     // c) bereits in mandate db vorhanden
   */
  checking = false;
  checkJournal: string = '';
  isChecked = false;
  errorsFound = false;
  numberCorrect: number = 0;

  // do the check
  checkTransfer() {
    console.log('check transfers');
    this.checking = true;

    // check for dubletten in the TRANSFER items
    const seenIds: Set<string> = new Set();

    this.checkJournal += 'Prüfe TRANSFER <br>';

    // iterate all the rows
    this.dataSource.data.forEach((row) => {
      // init the errors
      row.errorId = 0;
      row.errorMessage = '';

      this.checkJournal += '.';

      // check for TRANSFER status
      // transferred = bereits transferd
      // status=3 >  status ungültig - gelöscht
      if (row.transferred == 0 || row.status_id == '3') {
        // its still in DRAFT mode
        row.errorMessage += 'In Arbeit';
        row.errorId += 100;
      } else {
        // ---------------------------------------------------------------------
        //
        // check ob das aktenzeichen bereits vorkommt (im transfer !)
        if (row.aktenzeichen !== undefined && row.aktenzeichen !== null) {
          if (seenIds.has(row.aktenzeichen)) {
            // This id has been seen more than once
            // console.log(`Duplicate id found: ${row.aktenzeichen}`);
            row.errorMessage += 'Aktenzeichen ist doppelt vorhanden';
            row.errorId += 2;

            this.checkJournal += '<br>' + row.aktenzeichen + ' Aktenzeichen ist doppelt vorhanden';

            this.errorsFound = true;
          } else {
            // First occurrence of the id
            seenIds.add(row.aktenzeichen);
          }
        }

        // ---------------------------------------------------------------------
        //
        // check ob das kennzeichen korrekt ist
        if (!this.checkKennzeichen(row.plate)) {
          row.errorMessage += 'Kennzeichen ist nicht korrekt per VSTV';
          row.errorId += 4;
          this.errorsFound = true;

          this.checkJournal += '<br>' + row.aktenzeichen + ' Kennzeichen ist nicht korrekt per VSTV';
        }

        // ---------------------------------------------------------------------
        //
        // check ob das mandat ? bereits in den mandaten vorkommt (uebertragen wurde)
        if (!this.checkAktenzeichenInMandate(row.aktenzeichen)) {
          row.errorMessage += 'Aktenzeichen wurde bereits zur Anzeige übermittelt';
          row.errorId += 8;
          this.errorsFound = true;

          this.checkJournal += '<br>' + row.aktenzeichen + ' Aktenzeichen wurde bereits zur Anzeige übermittelt';
        }

        // ---------------------------------------------------------------------
        //
        // in diesem fall ist alles OK -> show the
        if (row.errorId == 0) {
          row.errorMessage = 'Alles OK';
          row.errorId = 999;
          //this.errorsFound = true; --> do not change the values
          this.numberCorrect++;

          this.checkJournal += 'OK ';
        }
      }
    });

    this.checkJournal += '<br> Überprüfen auf Doppelte in TRANSFER Liste...Erledigt';
    this.checkJournal += '<br> Überprüfen auf inkorrekte Kennzeichen per VSTV...Erledigt';
    this.checkJournal += '<br> Überprüfen auf bereits übermittelt...Erledigt';
    this.checkJournal += '<br> Kontrolle abgeschlossen - Fertig.';
    this.checkJournal += '<br>';
    this.checkJournal += '<br> ' + this.numberCorrect + ' Transfer können überführt werden zu Mandate.';

    this.isChecked = true;
  }

  /**
   * checkKennzeichen
   *    > check if kennzeichen is korrekt for VSTV Export
   */
  checkKennzeichen(plate: string): boolean {
    console.log('check Kennzeichen');
    return true;
  }

  /**
   * checkAktenzeichenInMandate
   *    > check if Aktenzeichen is in Mandate already
   */
  checkAktenzeichenInMandate(plate: string): boolean {
    console.log('check Aktenzeichen in Mandate');
    return true;
  }

  /**
   * doTransfer2Mandate -> if everything is fine
   *    > create the mandate out of the transfer
   */
  transferSuccess = false;
  doTransfer2Mandate() {
    const count = this.selection.selected.length;
    const msg = count > 0
      ? `${count} ausgewählte Transfer-Einträge werden zu Mandate übertragen.`
      : 'Alle berechtigten Transfer-Einträge werden zu Mandate übertragen.';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Zu Mandate übertragen', message: msg + ' Möchten Sie fortfahren?' } as ConfirmDialogData,
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this._doTransfer2Mandate();
    });
  }

  private _doTransfer2Mandate() {
    console.log('do transfer');

    const selectedIds: number[] = this.selection.selected.map((r) => +r.id);

    let requestData: any = {
      api_key: new Date().getTime(),
      do: 'transfer2mandate',
    };

    if (selectedIds.length > 0) {
      requestData.selectedIds = selectedIds;
    }

    // update to the server
    this.transferService.doTransfer2Mandate(requestData).subscribe(
      (response: TransferMandat[]) => {
        //next() callback
        console.log('response received');
        console.log(response);

        // BUG BUG BUG ---> refreh the list
        //

        //
        // show some feedback --> snackbar ?
        this._snackBar.open('Datensätze erfolgreich zu Mandate übertragen', 'Schließen', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        this.transferSuccess = true;
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  /**
   * show the sidebar page
   * @param transfer_id
   *
   */

  showPageDetail(transfer_id: number) {
    if (!this.editingAllowed) {
      return;
    }
    console.log('load page: ' + transfer_id);

    // get the quiz page with given uuid
    let transfer: TransferMandat;
    transfer = <TransferMandat>(
      this.dataSource.filteredData.find((element: TransferMandat) => element.id == transfer_id)
    );
    this.currentTransferId = transfer_id;

    // load the component into the modal slide window
    //this.router.navigate(['/home/edit', visitor_id]);
    this.router.navigate([
      '/transfer/edit',
      { id: transfer_id, _uid: transfer.id, _fid: transfer_id, _role: 3, _country: transfer.plate, ia: 1 },
    ]);
    //, {my_object: JSON.stringify(this.Obj)}]));

    this.current_aktenzeichen = transfer.aktenzeichen;
    //this.showVisitor(visitor);
    //this.sidenav.open();
    //const mySidebar = <any>document.querySelectorAll('.offcanvas');
    //mySidebar.show();

    $('#staticBackdrop').offcanvas('show');
  }

  showVisitor(visitor: TransferMandat) {
    console.log('show the page');

    this.selectedVisitor = visitor;

    // load visitor - firststart
    //this.llStartPageEdit(visitor);
  }

  sidebarOnClose() {
    console.log('close');
    this.openSidebar = false;
  }

  additionalColumns: string[] = [
    'generalisttour',
    'specialisttour',
    'tourownretailing',
    'tourretailingtravelagencies',
    'touroperatormember',
    'travel',
    'incentive',
    'inernationalincoming',
    'coach',
    'carrental',
    'hotelbookingcallcenter',
    'aircarrier',
    'seacarrier',
    'roadcarrier',
    'railcarrier',
    'numberemployees',
    'volumegroups',
    'volumeindividuals',
    'numberbrochures',
    'onlinebooking',
  ];
  showAdditionalColumns() {
    this.displayedColumns = this.displayedColumns.concat(this.additionalColumns);
    console.log(this.displayedColumns);
  }

  //
  // -------------------------------
}
